import {NotificationsResource} from "../Api/User";
import Moment from "moment";

export default {
    namespaced: true,
    state: {
        items: [],
        meta: {
            first_page_url: null,
            from: null,
            last_page: null,
            last_page_url: null,
            next_page_url: null,
            path: null,
            per_page: null,
            prev_page_url: null,
            to: null,
            total: null,
        },
    },
    getters: {
        hasItems(state) {
            return state.items.length > 0
        },
        hasMore(state) {
            return state.meta.last_page > state.meta.current_page
        },
        unseenCount(state) {
            return state.items.filter(item => {
                return !item.seen_at
            }).length
        }
    },
    mutations: {
        setItems(state, items) {
            state.items = items
        },
        appendItems(state, items) {
            for (let i in items) {
                state.items.push(items[i])
            }
        },
        setMeta(state, meta) {
            state.meta = meta
        },
        addItem(state, item) {
            state.items.unshift(item)
        }
    },
    actions: {
        load(context, { page }) {
            page = parseInt(page)

            return new Promise((resolve, reject) => {
                NotificationsResource.all({ page }).then(r => {
                    if (page === 1) {
                        context.commit('setItems', r.data.data)
                    } else {
                        context.commit('appendItems', r.data.data)
                    }

                    delete(r.data.data)
                    context.commit('setMeta', r.data)
                    resolve(r.data)
                }).catch(e => handleApiError(e, reject))
            })
        },
        markAllRead(context) {
            return new Promise((resolve, reject) => {
                NotificationsResource.markAllRead()
                    .then(() => {
                        let items = context.state.items.map(item => {
                            item.read_at = Moment()
                            return item
                        })

                        context.commit('setItems', items)

                        resolve()
                    })
                    .catch(e => handleApiError(e, reject))
            })
        },
        markAllSeen(context) {
            return new Promise((resolve, reject) => {
                NotificationsResource.markAllSeen()
                    .then(() => {
                        let items = context.state.items.map(item => {
                            item.seen_at = Moment()
                            return item
                        })

                        context.commit('setItems', items)

                        resolve()
                    })
                    .catch(e => handleApiError(e, reject))
            })
        },
        markRead(context, notification_id) {
            return new Promise((resolve, reject) => {
                NotificationsResource.markRead(notification_id)
                    .then(() => {
                        let items = context.state.items.map(item => {
                            if (item.id === notification_id) {
                                item.read_at = Moment()
                            }
                            return item
                        })

                        context.commit('setItems', items)

                        resolve()
                    })
                    .catch(e => handleApiError(e, reject))
            })
        },
        markUnread(context, notification_id) {
            return new Promise((resolve, reject) => {
                NotificationsResource.markUnread(notification_id)
                    .then(() => {
                        let items = context.state.items.map(item => {
                            if (item.id === notification_id) {
                                item.read_at = null
                            }
                            return item
                        })

                        context.commit('setItems', items)

                        resolve()
                    })
                    .catch(e => handleApiError(e, reject))
            })
        },
        destroy(context, notification_id) {
            return new Promise((resolve, reject) => {
                NotificationsResource.destroy(notification_id)
                    .then(() => {
                        let items = context.state.items.filter(item => {
                            return item.id !== notification_id
                        })

                        context.commit('setItems', items)

                        resolve()
                    })
                    .catch(e => handleApiError(e, reject))
            })
        },
        destroyAll(context) {
            return new Promise((resolve, reject) => {
                NotificationsResource.destroyAll()
                    .then(() => {
                        context.commit('setItems', [])

                        resolve()
                    })
                    .catch(e => handleApiError(e, reject))
            })
        }
    }
}